/**
 * @file NotFound.js
 * @author Stanley Chen
 * @description 404 error page component that displays when users navigate to
 * non-existent routes, with options to return to homepage or menu
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found">
            <img src="/images/mtnbg.jpg" alt="Background" className="not-found-background" />
            <div className="not-found-content">
                <motion.h1
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    404
                </motion.h1>
                <motion.h2
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                >
                    Page Not Found
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    The page you're looking for doesn't exist or has been moved.
                </motion.p>
                <motion.div
                    className="not-found-buttons"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                >
                    <Link to="/">
                        <motion.button
                            className="primary-btn"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Go Home
                        </motion.button>
                    </Link>
                    <Link to="/menu">
                        <motion.button
                            className="secondary-btn"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            View Menu
                        </motion.button>
                    </Link>
                </motion.div>
            </div>
        </div>
    );
};

export default NotFound;